// Libs
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import classNames from 'classnames/bind';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { BusinessTypeEnum } from '~/utils/enum/common';
import { ISchedule } from '~/utils/interface/schedule';
// Styles, images, icons
import { icons } from '~/assets';
import styles from './MoreEvent.module.scss';

type Props = {
  eventList?: ISchedule[];
  onSelectEvent?: (event: ISchedule) => void;
  onClose: () => void;
};

const cx = classNames.bind(styles);

const MoreEvent = (props: Props) => {
  //#region Destructuring Props
  const { eventList, onSelectEvent, onClose } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/schedule']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const renderEventIcon = (businessType?: string) => {
    switch (businessType) {
      case BusinessTypeEnum.JOB:
        return icons.menuIconJobsInactive;

      case BusinessTypeEnum.ESTIMATE:
        return icons.menuIconEstimateInactive;

      case BusinessTypeEnum.EVENT:
        return icons.menuIconScheduleInactive;

      case BusinessTypeEnum.TASK:
        return icons.menuIconTasksInactive;

      default:
        return EMPTY_STRING;
    }
  };

  const handleSelectEvent = (eventSelected: ISchedule) => {
    if (!eventSelected) return;
    onSelectEvent && onSelectEvent(eventSelected);
  };

  const handleCancel = () => {
    onClose();
  };
  //#endregion Handle Function

  return (
    <Dialog id='moreEventModal' open={true} fullWidth maxWidth={'xs'} onClose={handleCancel}>
      <DialogTitle>{t('schedule_modal_show_more_title')}</DialogTitle>

      <DialogContent className={cx('body')} sx={{ maxHeight: 500 }}>
        {eventList &&
          eventList?.map((event: ISchedule) => {
            const eventColor = event?.displayColor;

            return (
              <Box
                key={event.id}
                component={'div'}
                className={cx('eventContainer')}
                sx={{ borderWidth: 1, borderColor: eventColor, backgroundColor: eventColor }}
                onClick={() => handleSelectEvent(event)}
              >
                <Stack direction={'row'} alignItems={'flex-start'} gap={'8px'} className={cx('eventGroup')}>
                  <Box component={'div'} className={cx('eventIcon')}>
                    {renderEventIcon(event?.businessType) && (
                      <img
                        src={renderEventIcon(event?.businessType)}
                        alt={cx('common_alt_img', { ns: 'common/base' })}
                        className={cx('eventIconImg')}
                      />
                    )}
                  </Box>

                  <Stack direction={'column'} gap={'4px'} className={cx('eventInfo')}>
                    <Typography className={cx('eventName')}>{event?.eventName || EMPTY_STRING}</Typography>
                    <Typography className={cx('eventTime')}>
                      {moment(event.startTime).format('hh:mm A')} - {moment(event.endTime).format('hh:mm A')}
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
            );
          })}
      </DialogContent>

      <DialogActions>
        <Stack direction={'row'} component={'div'}>
          <Button variant='outlined' onClick={handleCancel}>
            {t('common_action_cancel', { ns: 'common/base' })}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default MoreEvent;
